import { render, staticRenderFns } from "./HypothesisDocInDashboard.vue?vue&type=template&id=bd5ab754&"
import script from "./HypothesisDocInDashboard.vue?vue&type=script&lang=js&"
export * from "./HypothesisDocInDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports